export default __webpack_public_path__ + "static/media/locusofcontrol6Img1.8f2dc366.png";